$(document).ready(function() {

  // SUBSCRIBE POPUP
  $(function() {
    if (Cookies.get('alreadySeen') == null) {
      setTimeout(function() {
        $('#subscribe-popup').fadeIn();
        Cookies.set('alreadySeen', true, {expires: 1});
      }, 5000);
    }
  });
  $('#subscribe-popup #close').click(function() {
    $('#subscribe-popup').hide();
  });
  $('#subscribe-popup #mc-embedded-subscribe').attr('disabled', true);
  $('#subscribe-popup #mce-EMAIL').keyup(function() {
      if($(this).val().length != 0) {
        $('#subscribe-popup #mc-embedded-subscribe').attr('disabled', false);
      } else {
        $('#subscribe-popup #mc-embedded-subscribe').attr('disabled', true);
      }
  });
  
  // HOMEPAGE
  if ($('.template-index').length > 0) {
    // Set height for hero video
    $('#hero-background').css('height', $(window).height() - $('#shopify-section-header').height());
  }

  // INDIVIDUAL PRODUCT
  if ($('.template-product').length > 0) {
    // Product accessories
    setTimeout(function() {
      $('.accessories-item').each(function() {
        $(this).find('.accessory-price').insertAfter($(this).find('.accessoryQuantity'))/*.css('display','inline-block')*/;
      });
    }, 1200);
    // Tabs
    $('.tabs a').click(function() {
      $('.tabs a').removeClass('active');
      $('.tabs-content > div').removeClass('active');
      $(this).addClass('active');
      $('#' + $(this).attr('data-filter')).addClass('active');
    });
    // Move video below image & description
    $('.product-single__description .grid__item').insertAfter('.product-single > div:nth-of-type(2)');
  }
  
  // CART PAGE
  if ($('.template-cart').length > 0) {
    // Move WPD discount code field down
    setTimeout(function() {
      $('.wcp-messages').insertAfter($('.cart-subtotal__price'));
    }, 1000);
    /*
    // Agree to terms from debut code
    $('[name="checkout"]').click(function() {
      if ($('#agree').is(':checked')) {
        $(this).submit();
      }
      else {
        alert("You must agree with the Terms & Conditions before you can proceed.");
        return false;
      }
    });*/
  }  

});


  